<template>
  <div class="quota-content">
    <!-- 额度信息 -->
    <div class="content-line line-one">
      <div class="item-half">
        <div class="item-title" style="margin-bottom: 0px">融资额度</div>
        <div class="item-content left-con flex-con">
          <div id="chartsContainer"></div>
          <div class="quota-info">
            <div class="info-one">
              融资额度：<span class="red-num">{{
                `${getMoney(this.detailData.financingQuota)}`
              }}</span
              ><span>元</span>
            </div>
            <div class="info-one">
              已用额度：<span>{{
                `${getMoney(detailData.usedFinancingQuota)}元`
              }}</span>
            </div>
            <div class="info-one">
              可用额度：<span>{{
                `${getMoney(detailData.usableFinancingQuota)}元`
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="item-half">
        <div class="item-title">当前额度信息</div>
        <div class="quota-form flex-con">
          <div
            class="form-item"
            v-for="(item, index) in presentQuotaInfoConfig"
            :key="index"
          >
            <div class="item-name">{{ item.name }}:</div>
            <div class="item-value">{{ detailData[item.prop] }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-line">
      <div class="inner-content">
        <div class="item-title">额度明细列表</div>
        <div class="table-con">
          <avue-crud :data="quotaDetailList" :option="quotaDetailListConfig">
            <template slot="money" slot-scope="{ row }">
              <div
                :class="[
                  row.quotaType == 1
                    ? 'green_icon'
                    : row.quotaType == 2
                    ? 'red_icon'
                    : '',
                ]"
                @click="handleEdit(row)"
              >
                {{ row.quotaType == 1 ? "-" : row.quotaType == 2 ? "+" : "" }}
                {{ row.money }}
              </div>
            </template>
          </avue-crud>
        </div>
      </div>
    </div>
    <div class="content-line">
      <div class="inner-content">
        <div class="item-title">历史授信列表</div>
        <div class="table-con">
          <avue-crud :data="creditData" :option="creditHistoryConfig">
            <template slot="quotaStatus" slot-scope="{ row }">
              <div class="quota-status" v-if="row.status == 1">生效</div>
              <div class="quota-status red-point" v-else>失效</div>
            </template>
          </avue-crud>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  highchartsQuotaConfig,
  presentQuotaInfoConfig,
  quotaDetailListConfig,
  creditHistoryConfig,
} from "../quotaConfig.js";
import { getQuotaList, getQuotaDetail } from "@/api/factoring/factoringQuota";

import Highcharts from "highcharts";
import Highcharts3D from "highcharts/highcharts-3d";
import util from "@/mixins/util";
Highcharts3D(Highcharts);
export default {
  name: "QuotaContent",
  mixins: [util],
  data() {
    return {
      detailData: {},
      quotaDetailList: [],
      creditData: [],
      presentQuotaInfoConfig: presentQuotaInfoConfig(),
      quotaDetailListConfig: quotaDetailListConfig(this.getMoney),
      creditHistoryConfig: creditHistoryConfig(this.getMoney),
      chartConfig: highchartsQuotaConfig(),
    };
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  async mounted() {
    this.creditData = await this.queryQuotaDetail(this.id);

    this.detailData = this.creditData[0];

    this.quotaDetailList = await this.detail(this.creditData[0].id);

    this.detailData.financingQuotaStr = `${this.getMoney(
      this.detailData.financingQuota
    )}元`;
    this.detailData.statusStr = this.detailData.status == 1 ? "生效" : "失效";
    this.detailData.isGroupCreditStr =
      this.detailData.isGroupCredit == 1 ? "是" : "否";
    let dataList = [{ code: "factoring_loop_credit", name: "isLoopCredit" }];
    let dataSource = await this.dictionaryMap(dataList, this.detailData);
    this.detailData = dataSource;

    // this.detailData.isLoopCreditStr =
    //   this.detailData.isLoopCredit == 1 ? "是" : "否";

    // 处理图表数据
    this.chartConfig.series[0].data[0].y = Number(
      this.detailData.usableFinancingQuota
    );
    // this.chartConfig.series[0].data[0].y = 10000;
    this.chartConfig.series[0].data[1].y = Number(
      this.detailData.usedFinancingQuota
    );
    // this.chartConfig.series[0].data[1].y = 40000;
    // 生成表格
    Highcharts.chart("chartsContainer", this.chartConfig);
  },
  methods: {
    detail(id) {
      return new Promise(async (resolve, reject) => {
        let res = await getQuotaDetail({ id: id });
        if (res.data.code == 200) {
          resolve(res.data.data.quotaDetails);
        } else {
          this.$message({
            type: "warning",
            message: res.data.msg,
          });
        }
      });
    },

    queryQuotaDetail(id) {
      return new Promise(async (resolve, reject) => {
        let res = await getQuotaList({ blCustId: id, current: 1, size: 100 });
        if (res.data.code == 200) {
          resolve(res.data.data.records);
        } else {
          this.$message({
            type: "warning",
            message: res.data.msg,
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.quota-content {
  padding: 15px;
  .flex-con {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
  .line-one {
    width: 100%;
    min-width: 1150px;
    height: 300px;
    // min-width: 300px;
  }
  .content-line {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    .item-title {
      width: 100%;
      position: relative;
      padding-left: 30px;
      line-height: 14px;
      font-size: 14px;
      font-weight: 700;
      margin-bottom: 20px;
      color: #666;
    }
    .item-title::before {
      position: absolute;
      width: 7px;
      height: 7px;
      border-radius: 4px;
      top: 4px;
      left: 12px;
      content: "";
      background-color: #409eff;
    }
    .item-half {
      width: 49.5%;
      height: 100%;
      background-color: #fff;
      border-radius: 10px;
      padding: 20px 10px;
      box-shadow: rgba(0, 0, 0, 0.047) 0px 0px 5px;
      font-family: 微软雅黑, sans-serif;
      font-weight: 400;
      font-style: normal;
      .quota-form {
        width: 100%;
        padding: 0 20px;
        .form-item {
          width: 50%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .item-name {
            line-height: 50px;
            color: rgb(153, 153, 153);
            text-align: right;
            font-weight: 700;
            width: 35%;
            margin-right: 10px;
          }
          .item-value {
            font-family: "微软雅黑", sans-serif;
            font-weight: 400;
            font-style: normal;
            font-size: 13px;
            color: #333;
          }
        }
      }
      .item-content {
        #chartsContainer {
          width: 60%;
          height: 250px;
        }
        .quota-info {
          width: 35%;
          .info-one {
            font-weight: 700;
            font-style: normal;
            color: rgb(153, 153, 153);
            font-size: 14px;
            .red-num {
              color: #fb6260;
              font-size: 16px;
              font-weight: 700;
            }
            span {
              width: 35%;
              color: #333;
              font-weight: 400;
              line-height: 28px;
              font-size: 14px;
            }
          }
        }
      }
    }
    .inner-content {
      width: 100%;
      height: 100%;
      background-color: #fff;
      border-radius: 10px;
      padding: 20px 10px;
      box-shadow: rgba(0, 0, 0, 0.047) 0px 0px 5px;
      font-family: 微软雅黑, sans-serif;
      font-weight: 400;
      font-style: normal;
      .quota-status {
        position: relative;
        padding-left: 20px;
      }
      .quota-status::before {
        position: absolute;
        content: "";
        background-color: #19b16b;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        left: 12px;
        top: 7px;
      }
      .red-point::before {
        color: #f56c6c !important;
      }
    }
  }
  /deep/.avue-crud__menu {
    display: none;
    min-height: 0 !important;
    margin-bottom: 0 !important;
  }
}
.green_icon {
  color: rgb(25, 190, 107);
}
.red_icon {
  color: rgb(251, 98, 96);
}
</style>